<template>
  <router-view />
</template>

<script setup>
// 不需要导入Layout组件，路由会根据配置自动处理
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
</style>
